<template>
  <label :for="this.for" class="form-label">
    <slot />
  </label>
</template>

<script>
export default {
  name: 'FormInput',
  props: {
    for: {
      type: String,
      default: '0'
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * FormLabel
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Form label
 * @since 2021-04-08
**/

$component: 'form-label';

.#{$component} {
  display: block;
  @include margin-bottom(map-get($spacers, 2));

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
